import { AutogenModelStop, AutogenRowStop } from "./autogen/AutogenModelStop";

export class ModelStop extends AutogenModelStop<RowStop> {
    constructor() {
        super(RowStop);
    }
}

export class RowStop extends AutogenRowStop {
}